import { ProductLoader } from "theme";

const sArrowLeft =
  '<img class="slide-arrow prev-arrow" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MyIgaGVpZ2h0PSI0MSIgdmlld0JveD0iMCAwIDQzIDQxIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzIxMSIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgMjExIiBvcGFjaXR5PSIwLjc5NSI+CiAgICA8ZWxsaXBzZSBpZD0i5qWV5YaG5b2iXzc4IiBkYXRhLW5hbWU9IualleWGhuW9oiA3OCIgY3g9IjIxLjUiIGN5PSIyMC41IiByeD0iMjEuNSIgcnk9IjIwLjUiIGZpbGw9IiNkZGJhYzkiLz4KICAgIDxwYXRoIGlkPSLjg5HjgrlfNTkiIGRhdGEtbmFtZT0i44OR44K5IDU5IiBkPSJNMzc3NC4zNjIsMjE3OC41NzNsLTEyLjgxMSwxMi43NTUsMTIuODExLDEyLjgxMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM3NDYuMzg0IC0yMTcwLjc3KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmZGZlIiBzdHJva2Utd2lkdGg9IjMiLz4KICA8L2c+Cjwvc3ZnPgo="/>';
const sArrowRight =
  '<img class="slide-arrow next-arrow" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MyIgaGVpZ2h0PSI0MSIgdmlld0JveD0iMCAwIDQzIDQxIj4KICA8ZyBpZD0i44Kw44Or44O844OXXzIxMiIgZGF0YS1uYW1lPSLjgrDjg6vjg7zjg5cgMjEyIiBvcGFjaXR5PSIwLjc5NiI+CiAgICA8ZWxsaXBzZSBpZD0i5qWV5YaG5b2iXzc4IiBkYXRhLW5hbWU9IualleWGhuW9oiA3OCIgY3g9IjIxLjUiIGN5PSIyMC41IiByeD0iMjEuNSIgcnk9IjIwLjUiIGZpbGw9IiNkZGJhYzkiLz4KICAgIDxwYXRoIGlkPSLjg5HjgrlfNTkiIGRhdGEtbmFtZT0i44OR44K5IDU5IiBkPSJNMzc2MS41NTEsMjE3OC41NzNsMTIuODExLDEyLjc1NS0xMi44MTEsMTIuODExIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzc0Ni41MjkgLTIxNzAuNzcpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZkZmUiIHN0cm9rZS13aWR0aD0iMyIvPgogIDwvZz4KPC9zdmc+Cg=="/>';
const iconArrowLeftBase64 =
  '<img alt="left" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC40ODIiIGhlaWdodD0iNDguNDg1IiB2aWV3Qm94PSIwIDAgMjguNDgyIDQ4LjQ4NSI+CiAgPHBhdGggaWQ9IlBhdGhfNjEiIGRhdGEtbmFtZT0iUGF0aCA2MSIgZD0iTTEwMTQ0LjUsMTExOGwtMjAsMjAsMjAsMjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDEyMC4yNiAtMTExMy43NTMpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZkZmQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI2Ii8+Cjwvc3ZnPgo=" />';
const iconArrowRightBase64 =
  '<img alt="right" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC40ODQiIGhlaWdodD0iNDguNDg1IiB2aWV3Qm94PSIwIDAgMjguNDg0IDQ4LjQ4NSI+CiAgPHBhdGggaWQ9IlBhdGhfNjEiIGRhdGEtbmFtZT0iUGF0aCA2MSIgZD0iTTEwMTI0LjUsMTExOGwyMCwyMC0yMCwyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwMTIwLjI1OCAtMTExMy43NTMpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZkZmQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI2Ii8+Cjwvc3ZnPgo=" />';
const iconArrowLeftSpBase64 =
  '<img alt="left" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjA1IiBoZWlnaHQ9IjE1LjI3MiIgdmlld0JveD0iMCAwIDkuMDUgMTUuMjcyIj4KICA8cGF0aCBpZD0iUGF0aF82MSIgZGF0YS1uYW1lPSJQYXRoIDYxIiBkPSJNMTAxMzAuNzIzLDExMzIuNTYxbC03LjYzNi03LjYzNiw3LjYzNi03LjYzNiwxLjQxNCwxLjQxNC02LjIyMiw2LjIyMiw2LjIyMiw2LjIyMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDEyMy4wODcgLTExMTcuMjg4KSIgZmlsbD0iI2ZmZmRmZCIvPgo8L3N2Zz4K" />';
const iconArrowRightSpBase64 =
  '<img alt="right" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjA1IiBoZWlnaHQ9IjE1LjI3MiIgdmlld0JveD0iMCAwIDkuMDUgMTUuMjcyIj4KICA8cGF0aCBpZD0iUGF0aF82MSIgZGF0YS1uYW1lPSJQYXRoIDYxIiBkPSJNMTAxMjUuMjA3LDExMzIuNTYxbC0xLjQxNC0xLjQxNCw2LjIyMi02LjIyMi02LjIyMi02LjIyMiwxLjQxNC0xLjQxNCw3LjYzNiw3LjYzNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDEyMy43OTMgLTExMTcuMjg4KSIgZmlsbD0iI2ZmZmRmZCIvPgo8L3N2Zz4K" />';

// --- 背景スクロールロックの共通処理 ---
// 絞り込みパネル・ハンバーガーメニューなど、複数のオーバーレイが同じbodyロックを
// 独立して奪い合わないよう、開いている数（lockCount）で管理する
window.LafaryScrollLock = window.LafaryScrollLock || (function ($) {
  var lockCount = 0;
  var savedScrollPosition = 0;

  function lock() {
    if (lockCount === 0) {
      savedScrollPosition = $(window).scrollTop();
      $("body").css({
        position: "fixed",
        top: "-" + savedScrollPosition + "px",
        width: "100%",
      });
    }
    lockCount++;
  }

  function unlock() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      $("body").css({ position: "", top: "", width: "" });
      $(window).scrollTop(savedScrollPosition);
    }
  }

  return { lock: lock, unlock: unlock };
})(jQuery);

// JavaScript Document
(function ($) {
  $(function () {
    const $slide = $(".lyt-slider");
    const $navigation = $(".lyt-slider__nav .item");

    $(".lyt-slider").on("init", function (event, slick) {
      $(".lyt-slider").removeClass("_hidden");
      // 非表示（display:none）の状態で幅0として初期化されてしまうため、
      // 表示状態に戻した直後に寸法を再計算させる
      // ※initの時点では要素にslickインスタンスが未登録のため、
      //   $(this).slick("setPosition")はエラーになる。引数のインスタンスを使う
      slick.setPosition();
    });

    $slide.slick({
      //slickスライダー作成
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      prevArrow: sArrowLeft,
      nextArrow: sArrowRight,
    });
    $navigation.each(function (index) {
      //サムネイルに連番付与属性
      $(this).attr("data-number", index);
    });
    $navigation.eq(0).addClass("current"); //1枚をオーバーレイ

    $navigation.on("click", function () {
      //サムネイルクリック時イベント
      var number = $(this).attr("data-number");
      $slide.slick("slickGoTo", number, true);

      // afterChangeイベントでcurrentクラスを付与するので不要
      // $(this).siblings().removeClass("current");
      // $(this).addClass("current");
    });

    // スライドが変わった後のイベント
    $(".lyt-slider").on("afterChange", function (event, slick, currentSlide) {
      $(".lyt-slider__nav .item.current").removeClass("current");
      const $target = $(
        '.lyt-slider__nav .item[data-number="' + currentSlide + '"]'
      );
      $target.addClass("current");
    });

    // variant pickerで選択したらスライドを切り替える
    $(async function () {
      const $variantPicker = $("variant-picker");
      if (!$variantPicker) return;
      const handle = $variantPicker.attr("handle");
      const product = await ProductLoader.load(handle);
      const form = $variantPicker.attr("form");
      const targetForm = document.forms[form];
      if (!targetForm) return;

      targetForm.addEventListener("variant:change", (event) => {
        const variantId = targetForm.id.value;
        const variant = product["variants"].find(
          (variant) => variant["id"] === parseInt(variantId)
        );

        const images = $(
          ".lyt-slider__nav .item[data-media-id='" +
            variant["featured_media"]["id"] +
            "']"
        );
        if (images.length === 0) return;
        $slide.slick("slickGoTo", $(images[0]).attr("data-number"), true);
      });
    });
  });

  // MVスライダーの初期化
  // テーマエディタでセクションが再読み込みされた時にも呼び直せるよう関数化
  function initMvSlider($slider) {
    if (!$slider.length || $slider.hasClass("slick-initialized")) return;

    $slider.on("init", function (event, slick) {
      $(this).removeClass("_hidden");
      // 非表示（display:none）の状態で幅0として初期化されてしまうため、
      // 表示状態に戻した直後に寸法を再計算させる
      // ※initの時点では要素にslickインスタンスが未登録のため、
      //   $(this).slick("setPosition")はエラーになる。引数のインスタンスを使う
      slick.setPosition();
    });

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 2500,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "23.5%",
      arrows: true,
      dots: true,
      prevArrow: `<button type="button" class="slick-prev" aria-label="戻る">${iconArrowLeftBase64}</button>`,
      nextArrow: `<button type="button" class="slick-next" aria-label="次へ">${iconArrowRightBase64}</button>`,

      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            centerPadding: "5%",
            prevArrow: `<button type="button" class="slick-prev" aria-label="戻る">${iconArrowLeftSpBase64}</button>`,
            nextArrow: `<button type="button" class="slick-next" aria-label="次へ">${iconArrowRightSpBase64}</button>`,
          },
        },
      ],
    });
  }

  // テーマエディタでスライドを追加・編集するとセクションが素のHTML
  // （_hidden付き・スライダー未初期化）に差し替わり消えたように見えるため、
  // セクション再読み込みのたびに再初期化する
  document.addEventListener("shopify:section:load", function (e) {
    initMvSlider($(e.target).find(".mv-slider"));
  });

  $(function () {
    initMvSlider($(".mv-slider"));

    // // チェックした商品のスライダー
    // $(".lst-xScroll").slick(
    //   {
    //     infinite: false,
    //     centerMode: false,
    //     slidesToShow: 3.3,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     dots: false,
    //   }
    // );

    // チェックした商品のスライダー
    $(".lst-slick").slick({
      infinite: false,
      centerMode: false,
      slidesToShow: 3.3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
    });

    // # ハンバーガーメニュー
    // $('.header-menu').on('click', function() {
    //   $('.header-top-nav, .header-top-menu, .header-nav, .header-menu, .header-bg').toggleClass('is-open');
    //   return false;
    // });

    // $('.header-top-nav a, .header-top-nav, .header-nav a, .header-nav, .header-bg').on('click', function() {
    //   $('.header-top-nav a, .header-top-nav, .header-nav, .header-menu, .header-bg').removeClass('is-open');
    // });
     

// # ハンバーガーメニュー
  // --- メニューを開く関数 ---
  function openMenu() {
    window.LafaryScrollLock.lock();
    $('body').addClass('is-menu-open');

    // SPとPCで対象のメニューに 'is-open' クラスを追加する
    if (window.innerWidth <= 899) {
      $(".header-nav.is-sp").addClass("is-open");
    } else {
      $(".header-nav.is-pc").addClass("is-open");
    }
  }

  // --- メニューを閉じる関数 ---
  function closeMenu() {
    $('body').removeClass('is-menu-open');
    window.LafaryScrollLock.unlock();

    // SPとPC両方のメニューから 'is-open' クラスを削除する
    $(".header-nav.is-sp, .header-nav.is-pc").removeClass("is-open");
  }

  // bfcacheからの復元時、ロックが残っていたら解除する
  $(window).on("pageshow", function () {
    if ($("body").hasClass("is-menu-open")) {
      closeMenu();
    }
  });

  // SP/PCの境界（899px）を越えて、開いていたメニューがCSSで非表示になったらロックを解除する
  $(window).on("resize", function () {
    if (!$("body").hasClass("is-menu-open")) return;
    var isSpWidth = window.innerWidth <= 899;
    var openedAsSp = $(".header-nav.is-sp").hasClass("is-open");
    var openedAsPc = $(".header-nav.is-pc").hasClass("is-open");
    if ((openedAsSp && !isSpWidth) || (openedAsPc && isSpWidth)) {
      closeMenu();
    }
  });

  // # ハンバーガーメニューのクリックイベント
  $(".header-menu").on("click", function (e) {
    e.preventDefault();
    // すでにメニューが開いていたら閉じる、閉じていたら開く
    if ($("body").hasClass("is-menu-open")) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // # 閉じるボタン（×ボタン）のクリックイベント
  $(".header-nav__close, .header-nav__close-button").on("click", function (e) {
    e.preventDefault();
    // メニューが開いていれば閉じる
    if ($("body").hasClass("is-menu-open")) {
      closeMenu();
    }
  });

  // # 背景（メニュー外）クリックで閉じる処理
  $(document).on("click", function (e) {
    if ($("body").hasClass("is-menu-open")) {
      // メニュー本体と、メニューを開くボタン以外の場所をクリックしたら閉じる
      if (!$(e.target).closest(".header-nav__container").length && !$(e.target).closest(".header-menu").length) {
        closeMenu();
      }
    }
  });

    // # ページスクロール
    $(".header-top-nav__list a ,.header-nav__list a , .footer-nav__list a").on(
      "click",
      function () {
        var speed = 1500;
        var href = $(this).attr("href");
        if (href.match(/^#[a-zA-Z1-9]+/) != null) {
          var target = $(href == "#" ? "html" : href);
          var position = target.offset().top;
          $("html, body").animate(
            { scrollTop: position },
            speed,
            "easeOutQuint"
          );
        }
      }
    );

    // # トップへ戻る
    $(window).on("scroll", function () {
      var scrollHeight = $(document).height(); //ドキュメントの高さ
      var scrollPosition = $(window).height() + $(window).scrollTop(); //現在地
      var footHeight = $("footer").innerHeight() + 80; //footerの高さ（＝止めたい位置）
      if (scrollHeight - scrollPosition <= footHeight) {
        //ドキュメントの高さと現在地の差がfooterの高さ以下になったら
        $("#page-top").css({
          display: "none",
          opacity: "0",
          bottom: "30px",
          transition: "all 0.3s ease",
        });
      } else {
        //それ以外の場合は
        $("#page-top").css({
          display: "block",
          opacity: "1",
          position: "fixed",
          bottom: "30px",
          transition: "all 0.3s ease",
        });
      }
    });

    $("#page-top").click(function () {
      $("body,html").animate(
        {
          scrollTop: 0,
        },
        400
      );
      return false;
    });
  });

    $(function () {
    if ($("#nav-box-collection").length) {
      // グロナビ固定 （TOPページ）
      var scroll = 0;
      var navOffsetTop = $("#nav-box-collection").offset().top;
      var navHeight = $("#nav-box-collection").outerHeight();
      var headerWrapHeight = $(".header-wrap").outerHeight();
      var isFixedHeader = $(".header-container").hasClass("is-fixed-header");

      var $clone = $("#nav-box-collection").clone();
      $clone.attr("id", "header-box-collection");
      $(".header-container").append($clone);

      $(window).scroll(function () {
        // 絞り込みパネル・ハンバーガーメニュー表示中はヘッダー追従を停止
        if ($("body").hasClass("is-filter-open") || $("body").hasClass("is-menu-open")) return;

        if ($(window).scrollTop() > navOffsetTop + navHeight) {
          $(".header-container").addClass("is-scrolled");

          if (!isFixedHeader) {
            if ($(this).scrollTop() < scroll) {
              //上スクロールの時の処理
              $(".header-container")
                .addClass("to-upper")
                .removeClass("to-bottom")
                .css({ transform: `translateY(0px)` });
            } else {
              //下スクロールの時の処理
              $(".header-container")
                .addClass("to-bottom")
                .removeClass("to-upper")
                .css({ transform: `translateY(-${headerWrapHeight}px)` });
            }
          }
        } else {
          $(".header-container").removeClass("is-scrolled to-upper to-bottom");
          if (!isFixedHeader) {
            $(".header-container").css({ transform: "" });
          }
        }

        scroll = $(this).scrollTop();
      });
    } else {
      // グロナビ固定 （TOPページ以外）
      var scroll = 0;
      var headerWrapHeight = $(".header-wrap").outerHeight();
      var isFixedHeader = $(".header-container").hasClass("is-fixed-header");

      $(window).scroll(function () {
        // 絞り込みパネル・ハンバーガーメニュー表示中はヘッダー追従を停止
        if ($("body").hasClass("is-filter-open") || $("body").hasClass("is-menu-open")) return;

        if ($(window).scrollTop() > headerWrapHeight) {
          $(".header-container").addClass("is-scrolled");

          if (!isFixedHeader) {
            if ($(this).scrollTop() < scroll) {
              //上スクロールの時の処理
              $(".header-container")
                .addClass("to-upper")
                .removeClass("to-bottom")
                .css({ transform: `translateY(0px)` });
            } else {
              //下スクロールの時の処理
              $(".header-container")
                .addClass("to-bottom")
                .removeClass("to-upper")
                .css({ transform: `translateY(-${headerWrapHeight}px)` });
            }
          }
        } else {
          $(".header-container").removeClass("is-scrolled to-upper to-bottom");
          if (!isFixedHeader) {
            $(".header-container").css({ transform: "" });
          }
        }

        scroll = $(this).scrollTop();
      });
    }

    // テーマエディタでヘッダーの「常に固定表示にする」設定が変更され、
    // セクションがAJAXで再読み込みされた際に isFixedHeader を最新の状態に更新する
    document.addEventListener("shopify:section:load", function () {
      isFixedHeader = $(".header-container").hasClass("is-fixed-header");
    });
  });

  // $(function () {
  //   if ($("#nav-box-collection").length) {
  //     // グロナビ固定 （TOPページ）
  //     var scroll = 0;
  //     var navOffsetTop = $("#nav-box-collection").offset().top;
  //     var navHeight = $("#nav-box-collection").outerHeight();
  //     var headerWrapHeight = $(".header-wrap").outerHeight();

  //     var $clone = $("#nav-box-collection").clone();
  //     $clone.attr("id", "header-box-collection");
  //     $(".header-container").append($clone);

  //     $(window).scroll(function () {
  //       if ($(window).scrollTop() > navOffsetTop + navHeight) {
  //         $(".header-container").addClass("is-scrolled");

  //         if ($(this).scrollTop() < scroll) {
  //           //上スクロールの時の処理
  //           $(".header-container")
  //             .addClass("to-upper")
  //             .removeClass("to-bottom")
  //             .css({ transform: `translateY(0px)` });
  //         } else {
  //           //下スクロールの時の処理
  //           $(".header-container")
  //             .addClass("to-bottom")
  //             .removeClass("to-upper")
  //             .css({ transform: `translateY(-${headerWrapHeight}px)` });
  //         }
  //       } else {
  //         $(".header-container").removeClass("is-scrolled to-upper to-bottom");
  //         $(".header-container").css({ transform: "" });
  //       }

  //       scroll = $(this).scrollTop();
  //     });
  //   } else {
  //     // グロナビ固定 （TOPページ以外）
  //     var scroll = 0;
  //     var headerWrapHeight = $(".header-wrap").outerHeight();

  //     $(".header-container").append($clone);

  //     $(window).scroll(function () {
  //       if ($(window).scrollTop() > headerWrapHeight) {
  //         $(".header-container").addClass("is-scrolled");

  //         if ($(this).scrollTop() < scroll) {
  //           //上スクロールの時の処理
  //           $(".header-container")
  //             .addClass("to-upper")
  //             .removeClass("to-bottom")
  //             .css({ transform: `translateY(0px)` });
  //         } else {
  //           //下スクロールの時の処理
  //           $(".header-container")
  //             .addClass("to-bottom")
  //             .removeClass("to-upper")
  //             .css({ transform: `translateY(-${headerWrapHeight}px)` });
  //         }
  //       } else {
  //         $(".header-container").removeClass("is-scrolled to-upper to-bottom");
  //         $(".header-container").css({ transform: "" });
  //       }

  //       scroll = $(this).scrollTop();
  //     });
  //   }
  // });

  //  #検索ボックス開閉 SP
  $(".header-search__open").on("click", function () {
    $(".header-search--sp__container").addClass("is-open");
  });
  $(".header-search__form-close").on("click", function () {
    $(".header-search--sp__container").removeClass("is-open");
  });

  $(function () {
    $(".js-ranking-menu").on("change", function () {
      var val = $(this).val();
      $(`.js-ranking-content._active`).addClass("_hidden");
      $(`.js-ranking-content._active`).removeClass("_active");

      $(`.js-ranking-content[data-index="${val}"]`).removeClass("_hidden");
      $(`.js-ranking-content[data-index="${val}"]`).addClass("_active");
    });
  });
  $(function () {
      // ボタンクリックイベントを設定
      $(".js-ranking-button").on("click", function () {
          // ボタンのインデックスを取得
          var val = $(this).data();
          if (typeof val === "object") {
              val = val.index; // オブジェクト内のindexを取得
          }
          $(".js-ranking-button._active").removeClass("_active");
          $(this).addClass("_active");
        
          $(`.js-ranking-content._active`).addClass("_hidden");
          $(`.js-ranking-content._active`).removeClass("_active");
          // 選択したコンテンツをアクティブに設定
          $(`.js-ranking-content[data-index="${val}"]`).removeClass("_hidden");
          $(`.js-ranking-content[data-index="${val}"]`).addClass("_active");
        console.log(val);
      });
  });
  // sort byのセレクトボックスイベント
  $(function () {
    $(".js-sortBy").on("change", function () {
      console.log("change");
      const selectedOption = $(this).val();
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", selectedOption);
      window.location.href = url.href;
    });
  });
})(jQuery);

//サジェスト機能追加
document.addEventListener("DOMContentLoaded", function () {
  const searchToggleBtn = document.querySelector(".header-search__toggle"); // 検索アイコン
  const searchContainer = document.querySelector(".header-search--predictive"); // PC検索エリア
  const searchInput = searchContainer.querySelector("input[name='q']"); // 検索入力フィールド
  const closeBtn = document.createElement("button"); // 閉じるボタンを作成

  // 閉じるボタンを設定
  closeBtn.innerHTML = "×";
  closeBtn.classList.add("search-close-btn");
  searchContainer.appendChild(closeBtn);

  // 検索アイコンをクリック → 検索フォームを表示
  searchToggleBtn.addEventListener("click", function () {
    searchContainer.classList.toggle("is-active");
    if (searchContainer.classList.contains("is-active")) {
      searchInput.focus(); // 自動フォーカス
    }
  });

  // 閉じるボタンをクリック → 検索フォームを非表示
  closeBtn.addEventListener("click", function () {
    searchContainer.classList.remove("is-active");
  });

  // フォーカス外れたら閉じる
  document.addEventListener("click", function (event) {
    if (!searchContainer.contains(event.target) && !searchToggleBtn.contains(event.target)) {
      searchContainer.classList.remove("is-active");
    }
  });
});



// sections/search-window.liquidのサジェスト機能
(function() {
  // プライベートなdebounce関数を定義
  const createDebounce = function(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // カスタム要素の定義
  class SectionPredictiveSearch extends HTMLElement {
    constructor() {
      super();
      // 初期化を遅延させて、DOMの準備を待つ
      requestAnimationFrame(() => this.setupSearchComponent());
    }

    setupSearchComponent() {
      // 要素の取得
      this.searchForm = this.querySelector('#predictive-search-form-section');
      this.searchInput = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector('#section-predictive-search');

      // 要素が見つからない場合は初期化しない
      if (!this.searchForm || !this.searchInput || !this.resultsContainer) {
        return;
      }

      this.abortController = null;
      this.setupEventListeners();
    }

    setupEventListeners() {
      const debouncedSearch = createDebounce(() => {
        if (this.searchInput.value.trim()) {
          this.handleInputChange();
        }
      }, 280);

      this.searchInput.addEventListener('input', debouncedSearch);
      this.searchForm.addEventListener('submit', e => this.handleSubmit(e));

      // クリックアウトの処理
      document.addEventListener('click', e => {
        if (!this.searchForm.contains(e.target) &&
            !this.resultsContainer.contains(e.target)) {
          this.clearResults();
        }
      });
    }

    async handleInputChange() {
      const query = this.searchInput.value.trim();
      if (!query) {
        this.clearResults();
        return;
      }

      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      const baseUrl = `${window.Shopify.routes.root}search`;
      const params = new URLSearchParams({
        q: query,
        section_id: 'custom-predictive-search', // 必要に応じて変更
        'resources[limit]': '10',
        'resources[limit_scope]': 'each'
      });
      const fullUrl = `${baseUrl}?${params}`;

      try {
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:loading:start', { bubbles: true })
        );

        const response = await fetch(fullUrl, {
          method: 'GET',
          headers: { 'Accept': '*/*' },
          signal: this.abortController.signal
        });

        if (!response.ok) {
          throw new Error(`Search request failed: ${response.status}`);
        }

        const textHtml = await response.text();
        this.updateResults(textHtml);

      } catch (error) {
        if (error.name === 'AbortError') {
          // 新しい入力で古いリクエストがキャンセル
          return;
        }
        // 他のエラー
        console.error('Search error:', error);
        this.clearResults();
      } finally {
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:loading:end', { bubbles: true })
        );
      }
    }

    updateResults(html) {
      try {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const resultsContent = tempDiv.querySelector('.shopify-section');
        const targetContainer = this.resultsContainer.querySelector('.predictive-search__content');

        if (resultsContent && targetContainer) {
          targetContainer.innerHTML = '';
          targetContainer.appendChild(document.importNode(resultsContent, true));
          this.resultsContainer.classList.add('is-active');
        }
        else { 
          this.clearResults(); 
        }

      } catch (error) {
        this.clearResults();
      }
    }

    clearResults() {
      const resultsContent = this.resultsContainer.querySelector('.predictive-search__content');
      if (resultsContent) {
        resultsContent.innerHTML = '';
        this.resultsContainer.classList.remove('is-active');
      }
    }

    handleSubmit(event) {
      if (!this.searchInput.value.trim()) {
        event.preventDefault();
      }
    }
  }

  // カスタム要素を定義
  if (!window.customElements.get('section-predictive-search')) {
    window.customElements.define('section-predictive-search', SectionPredictiveSearch);
  }
})();


document.addEventListener('DOMContentLoaded', () => {
  const input = document.querySelector('#predictive-search-form-section input[type="search"]');
  const content = document.querySelector('.predictive-search__content');

  if (!input || !content) return;

  // 入力イベントを監視して、内容がある場合だけ表示
  input.addEventListener('input', () => {
    if (input.value.trim().length > 0) {
      content.classList.add('is-active');
    } else {
      content.classList.remove('is-active');
    }
  });
});

// 商品ページ: 画像下キャプション（Altテキスト）の高さ揃え
// CSS側: .product-gallery__caption { min-height: var(--product-gallery-caption-min-height, 0px) }
(function () {
  function equalizeCaptions(carousel) {
    const captions = carousel.querySelectorAll('.product-gallery__caption');
    if (!captions.length) return;

    // いったんmin-heightを外して自然な高さを測る
    carousel.style.removeProperty('--product-gallery-caption-min-height');
    let max = 0;
    captions.forEach((caption) => {
      max = Math.max(max, caption.getBoundingClientRect().height);
    });
    carousel.style.setProperty('--product-gallery-caption-min-height', `${max}px`);

    // adaptive-heightが揃える前の高さでmax-heightを固定している場合があるので、
    // 現在のスライド高さで引き直す（theme.jsのadaptHeightと同じ計算）
    if (carousel.hasAttribute('adaptive-height') && carousel.selectedCell) {
      carousel.style.maxHeight = carousel.isScrollable
        ? `${carousel.selectedCell.clientHeight}px`
        : null;
    }
  }

  function equalizeAll() {
    document.querySelectorAll('.product-gallery__carousel').forEach(equalizeCaptions);
  }

  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeAll, 150);
  }

  customElements.whenDefined('scroll-carousel').then(() => {
    equalizeAll();

    // Webフォント適用で折り返し位置が変わることがあるため再計算
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(equalizeAll);
    }

    window.addEventListener('resize', onResize);

    // バリアント切替で非表示だったスライド（測定時は高さ0）が出てくることがあるため、
    // カルーセルのフィルタ後に再計算
    document.querySelectorAll('.product-gallery__carousel').forEach((carousel) => {
      carousel.addEventListener('carousel:filter', () => {
        requestAnimationFrame(() => equalizeCaptions(carousel));
      });
    });

    // テーマエディタでのセクション再読み込みに追従
    document.addEventListener('shopify:section:load', equalizeAll);
  });
})();